import React from 'react';

import Button from '../../../../components/Button';
import { asyncSimpleModal } from '../../../../lib/common';
import useOrderConfirmsCheck from '../../../../hooks/queries/order/useOrderConfirmsCheck';
import { ORDER_ITEM_STATUS } from '../../../../constants/service/app/orderConstants';
import ORDER_ERROR_MESSAGE from '../../../../constants/errorResponse/order';

const orderConfirmsCancelModal = async (errorCode) => {
  await asyncSimpleModal({
    type: 'error',
    title: '주문 상태 되돌리기 불가',
    message: ORDER_ERROR_MESSAGE[errorCode],
  });
};

const OpenOrderItemStatusChange = (props) => {
  const {
    text = '주문 상태 되돌리기',
    orderItemId,
    isDelay,
    orderItemStatus,
    cancelHistory,
    exchangeHistory,
    returnHistory,
    toggleModal,
  } = props;
  const { data } = useOrderConfirmsCheck(orderItemId, {
    enabled: orderItemStatus === ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION,
  });

  const onClick = () => {
    if (data?.cancelable === false) {
      return orderConfirmsCancelModal(data.reason);
    }

    toggleModal({
      name: 'orderItemStatusChangeModal',
      isOpen: true,
      data: {
        orderItemId,
        isDelay,
        orderItemStatus,
        cancelHistory,
        exchangeHistory,
        returnHistory,
      },
    });
  };

  return (
    <Button className="order-item-action-button last-action" isRadius color="primary" text={text} onClick={onClick} />
  );
};

export default OpenOrderItemStatusChange;
